import React from "react";
import { portfolioData as DATA } from "../../data/portfolioData";
import Badge from "../ui/Badge";
import Card from "../ui/Card";
import SectionTitle from "../ui/SectionTitle";

export default function Skills() {
  return (
    <div className="mx-auto max-w-6xl px-4 py-14" id="skills">
      <SectionTitle kicker="Stack" title="Skills" />

      <div className="grid gap-5 md:grid-cols-2">
        {DATA.skills.map((s) => (
          <Card key={s.group}>
            <div className="text-base font-semibold text-white">{s.group}</div>
            <div className="mt-3 flex flex-wrap gap-2">
              {s.items.map((i) => (
                <Badge key={i}>{i}</Badge>
              ))}
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
